module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1016-770fe6930674d574b970c308f1aeab8d.png";